import { Component, computed, effect, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrnDialogImports, BrnDialogRef, injectBrnDialogContext } from '@spartan-ng/brain/dialog';
import { BrnSelectImports } from '@spartan-ng/brain/select';
import { HlmButtonImports } from '@spartan-ng/helm/button';
import { HlmDialogImports } from '@spartan-ng/helm/dialog';
import { HlmLabelImports } from '@spartan-ng/helm/label';
import { HlmSelectImports } from '@spartan-ng/helm/select';

import { Site } from '../../../administration/gestion-sites/model/site.model';
import { RégionStore } from '../../../administration/gestion-sites/store/région.store';
import { Cartographie } from '../../../cartographie/models/cartographie.model';
import { TrierParPipe } from '../../../shared/pipes/trier-par.pipe';

@Component({
  selector: 'app-dialog-select-cfa',
  imports: [
    HlmDialogImports,
    HlmSelectImports,
    BrnSelectImports,
    TrierParPipe,
    HlmLabelImports,
    HlmButtonImports,
    BrnDialogImports,
    FormsModule,
  ],
  templateUrl: './dialog-select-cfa.component.html',
})
export class DialogSelectCfaComponent {
  readonly #régionStore = inject(RégionStore);
  readonly #dialogRef = inject<BrnDialogRef<Site>>(BrnDialogRef);

  readonly #dialogContext = injectBrnDialogContext<{ cartographie: Cartographie }>();

  readonly site = signal<Site | undefined>(undefined);

  readonly regions = computed(() => this.#régionStore.entities());

  constructor() {
    effect(() => this.#régionStore.charger(this.#dialogContext.cartographie.id));
  }

  close() {
    this.#dialogRef.close(this.site());
  }
}
